import AjaxRequest from './AjaxRequest';

export default class Setting
{
    getCutoffMonth() {
        return new AjaxRequest().get(`settings/access_month`, null);
    }
}
